import React from "react";
import useDocumentTitle from "./ui/common/document-title";

const TermsAndConditions: React.FC = () => {
  useDocumentTitle("Terms & Conditions")
  return (
    <div style={{ padding: "2rem", maxWidth: "1200px", margin: "0 auto" }}>
      <h1 style={{ marginBottom: "1.5rem" }}>Terms & Conditions</h1>
      
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ marginBottom: "1rem", fontSize: "1.5rem" }}>1. Acceptance of Terms</h2>
        <p style={{ marginBottom: "1rem", lineHeight: "1.6" }}>
          By accessing and using this service, you accept and agree to be bound by the terms and provision of this agreement. 
          If you do not agree to abide by the above, please do not use this service.
        </p>
      </section>

      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ marginBottom: "1rem", fontSize: "1.5rem" }}>2. Use License</h2>
        <p style={{ marginBottom: "1rem", lineHeight: "1.6" }}>
          Permission is granted to temporarily use this service for personal or business purposes. This is the grant of a license, 
          not a transfer of title, and under this license you may not:
        </p>
        <ul style={{ marginLeft: "2rem", marginBottom: "1rem", lineHeight: "1.6" }}>
          <li>Modify or copy the materials</li>
          <li>Use the materials for any commercial purpose or for any public display</li>
          <li>Attempt to reverse engineer any software contained in the service</li>
          <li>Remove any copyright or other proprietary notations from the materials</li>
        </ul>
      </section>

      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ marginBottom: "1rem", fontSize: "1.5rem" }}>3. User Account</h2>
        <p style={{ marginBottom: "1rem", lineHeight: "1.6" }}>
          You are responsible for maintaining the confidentiality of your account and password. You agree to accept responsibility 
          for all activities that occur under your account or password. You must notify us immediately of any unauthorized use of 
          your account or any other breach of security.
        </p>
      </section>

      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ marginBottom: "1rem", fontSize: "1.5rem" }}>4. Privacy Policy</h2>
        <p style={{ marginBottom: "1rem", lineHeight: "1.6" }}>
          Your use of this service is also governed by our Privacy Policy. Please review our Privacy Policy to understand our practices 
          regarding the collection and use of your personal information.
        </p>
      </section>

      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ marginBottom: "1rem", fontSize: "1.5rem" }}>5. Prohibited Uses</h2>
        <p style={{ marginBottom: "1rem", lineHeight: "1.6" }}>
          You may not use this service:
        </p>
        <ul style={{ marginLeft: "2rem", marginBottom: "1rem", lineHeight: "1.6" }}>
          <li>In any way that violates any applicable national or international law or regulation</li>
          <li>To transmit, or procure the sending of, any advertising or promotional material without our prior written consent</li>
          <li>To impersonate or attempt to impersonate the company, a company employee, another user, or any other person or entity</li>
          <li>In any way that infringes upon the rights of others, or in any way is illegal, threatening, fraudulent, or harmful</li>
        </ul>
      </section>

      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ marginBottom: "1rem", fontSize: "1.5rem" }}>6. Limitation of Liability</h2>
        <p style={{ marginBottom: "1rem", lineHeight: "1.6" }}>
          In no event shall the service providers, its suppliers, or its licensors be liable for any damages (including, without limitation, 
          damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials 
          on this service, even if the service provider or an authorized representative has been notified orally or in writing of the 
          possibility of such damage.
        </p>
      </section>

      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ marginBottom: "1rem", fontSize: "1.5rem" }}>7. Revisions and Errata</h2>
        <p style={{ marginBottom: "1rem", lineHeight: "1.6" }}>
          The materials appearing on this service could include technical, typographical, or photographic errors. We do not warrant that 
          any of the materials on its service are accurate, complete, or current. We may make changes to the materials contained on its 
          service at any time without notice.
        </p>
      </section>

      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ marginBottom: "1rem", fontSize: "1.5rem" }}>8. Changes to Terms</h2>
        <p style={{ marginBottom: "1rem", lineHeight: "1.6" }}>
          We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will 
          provide at least 30 days notice prior to any new terms taking effect. What constitutes a material change will be determined at 
          our sole discretion.
        </p>
      </section>

      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ marginBottom: "1rem", fontSize: "1.5rem" }}>9. Contact Information</h2>
        <p style={{ marginBottom: "1rem", lineHeight: "1.6" }}>
          If you have any questions about these Terms and Conditions, please contact us through the appropriate channels provided in the service.
        </p>
      </section>

      <section style={{ marginBottom: "2rem" }}>
        <p style={{ marginBottom: "1rem", lineHeight: "1.6", fontStyle: "italic", color: "#666" }}>
          Last updated: {new Date().toLocaleDateString()}
        </p>
      </section>
    </div>
  );
};

export default TermsAndConditions;
